import React, { Component } from 'react';


class Card extends Component {
  render() {
      return (
        <div class="card">
          <div class="card-header header-elements-inline">
            <h5 class="card-title">{this.props.title}</h5>
            <div class="header-elements">
              <div class="list-icons">
                        <a class="list-icons-item" data-action="collapse"></a>
                        {/** <a class="list-icons-item" data-action="remove"></a>**/}
                      </div>
                    </div>
          </div>

          <div class="card-body">
            {this.props.body}
          </div>
        </div>
	     )
  }
}

export default Card;
